import { Link } from 'react-router-dom';

export default function AppDownloadSection() {
  return (
    <section className="w-full flex flex-col lg:flex-row">
      <div className="lg:w-1/2 bg-background-950 py-16 md:py-24 px-4 md:px-6 lg:px-10 flex flex-col justify-center items-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-96 border-2 border-foreground-200 rounded-3xl"></div>
        </div>
        <div className="relative z-10 text-center lg:text-left">
          <p className="text-xs text-foreground-500 tracking-wider uppercase mb-4">
            随时随地 一手掌握
          </p>
          <div className="flex flex-col gap-0">
            <span className="text-5xl md:text-7xl lg:text-8xl font-heading font-black text-foreground-50 leading-none">
              爆料
            </span>
            <span className="text-5xl md:text-7xl lg:text-8xl font-heading font-black text-foreground-50 leading-none">
              吃瓜
            </span>
            <span className="text-5xl md:text-7xl lg:text-8xl font-heading font-black text-primary-400 leading-none">
              App
            </span>
          </div>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-300 py-16 md:py-24 px-4 md:px-6 lg:px-10 flex flex-col justify-center items-center text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-foreground-50 leading-tight">
          全网热议
          <br />
          不错过
        </h2>
        <p className="mt-6 max-w-md text-sm md:text-base text-foreground-400 leading-relaxed">
          下载爆料吃瓜App，随时随地掌握最新八卦动态。推送及时、界面清爽、无冗余广告，让你第一时间获取网红黑料、明星八卦和全网热议大瓜。
        </p>
        <Link
          to="/about"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-800 border border-secondary-600 text-foreground-100 font-medium text-sm hover:bg-background-700 hover:border-accent-500 transition-all duration-200"
        >
          立即下载
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}